export class WindowLocalStorage {
    constructor(logger) {
        this.logger = logger;
    }
    get(key) {
        this.logger.logInformation(`Reading from Local Storage by key '${key}'`);
        const item = localStorage.getItem(key);
        return item === null ? null : JSON.parse(item);
    }
    set(key, value) {
        this.logger.logInformation(`Saving to Local Storage by key '${key}'...`);
        localStorage.setItem(key, JSON.stringify(value));
    }
    hasKey(key) {
        return localStorage.getItem(key) !== null;
    }
    remove(key) {
        this.logger.logInformation(`Removing from Local Storage by key '${key}'...`);
        localStorage.removeItem(key);
    }
    clear() {
        this.logger.logInformation(`Clearing Local Storage (${localStorage.length} items in total)...`);
        localStorage.clear();
    }
}
